import React, { useState } from 'react';
import { Download, FileText, Award, Shield, CheckCircle, ExternalLink, Calendar, Building, Hash } from 'lucide-react';

const Certificazioni = () => {
  const [activeTab, setActiveTab] = useState('certificati');
  const [hoveredCard, setHoveredCard] = useState(null);
  
  const primaryColor = "#232D3B";
  
  const certificazioni = [
    {
      id: "certificato-eow",
      titolo: "Certificato End of Waste",
      descrizione: "Attestazione ufficiale che i materiali commercializzati dall'attività hanno cessato di essere rifiuti secondo i criteri EU.",
      dettagli: "Certifica la conformità al Regolamento UE n.333/2011 per rottami di ferro, acciaio ed alluminio e al Regolamento UE n.715/2013 per rottami di rame e leghe di rame.",
      pdfUrl: "/pdf/Certificato_EoW_Certiquality_MAS_METAL_64895_2024-2027.pdf",
      emissione: "04/09/2024",
      scadenza: "04/09/2027",
      ente: "Certiquality S.r.l."
    },
    {
      id: "lettera-conformita",
      titolo: "Lettera di Conformità EoW",
      descrizione: "Conferma della conformità del nostro sistema di gestione ai requisiti End of Waste previsti dai regolamenti europei.",
      dettagli: "Documento firmato dal Direttore Tecnico che attesta il superamento dell'audit di verifica presso la nostra unità operativa di Castegnato (BS).",
      pdfUrl: "/pdf/Lettera_Conformita_EoW_Certiquality_MAS_METAL_64895_04-09-2024.pdf",
      emissione: "04/09/2024",
      scadenza: "04/09/2027",
      ente: "Certiquality S.r.l."
    },
    {
      id: "albo-gestori",
      titolo: "Iscrizione Albo Gestori Ambientali",
      descrizione: "Autorizzazione per l'attività di intermediazione e commercio di rifiuti pericolosi e non pericolosi senza detenzione.",
      dettagli: "Iscrizione Categoria 8 (intermediazione) Classe F per quantità annua inferiore a 3.000 tonnellate, rilasciata dalla Sezione Regionale della Lombardia.",
      pdfUrl: "/pdf/Iscrizione_Albo_Gestori_MAS_METAL_Cat8F_2025-2030.pdf",
      emissione: "24/03/2025",
      scadenza: "24/03/2030",
      ente: "Camera di Commercio di Milano Monza Brianza Lodi"
    },
    {
      id: "garanzia-finanziaria",
      titolo: "Autorizzazione Unica Ambientale",
      descrizione: "Autorizzazione Unica Ambientale secondo le disposizioni normative vigenti.",
      dettagli: "Documentazione relativa all'Autorizzazione Unica Ambientale.",
      pdfUrl: "/pdf/Autorizzazione_Unica_Ambientale_MAS_METAL.pdf",
      emissione: "13/05/2025",
      scadenza: "13/05/2036", 
      ente: "Provincia di Brescia - Settore Sostenibilità Ambientale e Protezione Civile"
    }
  ];

  const normative = [
    {
      numero: "Regolamento UE n. 333/2011",
      titolo: "Rottami di ferro, acciaio e alluminio",
      descrizione: "Stabilisce i criteri che determinano quando i rottami di ferro, acciaio e alluminio cessano di essere considerati rifiuti e possono essere impiegati come materie prime secondarie. Definisce requisiti specifici per i sistemi di gestione della qualità e criteri di accettazione per i materiali in ingresso.",
      icona: <FileText size={22} className="text-amber-600" />
    },
    {
      numero: "Regolamento UE n. 715/2013",
      titolo: "Rottami di rame e leghe di rame",
      descrizione: "Stabilisce i criteri che determinano quando i rottami di rame e delle sue leghe cessano di essere considerati rifiuti, entrando nella categoria di materie prime secondarie. Definisce le caratteristiche tecniche e i limiti di contaminazione accettabili per il materiale End of Waste.",
      icona: <FileText size={22} className="text-amber-600" />
    },
    {
      numero: "D.Lgs. 152/2006",
      titolo: "Testo Unico Ambientale",
      descrizione: "Normativa nazionale di riferimento in materia ambientale, che regola tra l'altro la gestione dei rifiuti, le procedure di recupero e le autorizzazioni per intermediazione e commercio di sottoprodotti industriali.",
      icona: <FileText size={22} className="text-amber-600" />
    }
  ];

  return (
    <section id="certificazioni" className="py-24 bg-gradient-to-b from-gray-50 to-gray-100">
      <div className="container mx-auto px-4">
        {/* Intestazione */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center mb-6">
            <span className="w-16 h-[1px] bg-gray-300"></span>
            <span className="mx-4 text-gray-500 uppercase text-xs tracking-wider font-medium">Conformità e qualità</span>
            <span className="w-16 h-[1px] bg-gray-300"></span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ color: primaryColor }}>Certificazioni</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Mas Metal S.R.L. opera in piena conformità con le normative vigenti, garantendo la massima qualità e tracciabilità dei materiali commercializzati.
          </p>
        </div>

        {/* Tabs */}
        <div className="flex justify-center mb-14">
          <div className="inline-flex bg-white rounded-full shadow-md p-1.5">
            <button 
              className={`px-8 py-3 rounded-full text-sm font-medium transition-all duration-300 ${
                activeTab === 'certificati' 
                  ? `text-white shadow-lg` 
                  : 'text-gray-700 hover:text-gray-900 hover:bg-gray-50'
              }`}
              style={{ backgroundColor: activeTab === 'certificati' ? primaryColor : 'transparent' }}
              onClick={() => setActiveTab('certificati')}
            >
              Certificati Aziendali
            </button>
            <button 
              className={`px-8 py-3 rounded-full text-sm font-medium transition-all duration-300 ${
                activeTab === 'normative' 
                  ? `text-white shadow-lg` 
                  : 'text-gray-700 hover:text-gray-900 hover:bg-gray-50'
              }`}
              style={{ backgroundColor: activeTab === 'normative' ? primaryColor : 'transparent' }}
              onClick={() => setActiveTab('normative')}
            >
              Normative di Riferimento
            </button>
          </div>
        </div>

        {/* Contenuto principale */}
        <div className="transition-all duration-500">
          {activeTab === 'certificati' && (
            <div className="grid md:grid-cols-1 lg:grid-cols-2 gap-10">
              {certificazioni.map((cert, index) => (
                <div 
                  key={index}
                  className="group bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 transition-all duration-500 hover:shadow-2xl transform hover:-translate-y-1"
                  onMouseEnter={() => setHoveredCard(index)}
                  onMouseLeave={() => setHoveredCard(null)}
                >
                  {/* Intestazione certificato senza icona */}
                  <div className="relative p-6 border-b border-gray-100">
                    
                    <div className="mb-5">
                      <h3 className="text-xl font-bold mb-3" style={{ color: primaryColor }}>{cert.titolo}</h3>
                    </div>
                    
                    <p className="text-gray-600 mb-5">{cert.descrizione}</p>
                    
                    <div className="text-xs text-gray-500 space-y-1.5">
                      <div className="flex items-center">
                        <Calendar size={14} className="mr-2 flex-shrink-0" />
                        <span>Validità: {cert.emissione} - {cert.scadenza}</span>
                      </div>
                      <div className="flex items-center">
                        <Building size={14} className="mr-2 flex-shrink-0" />
                        <span>Emesso da: {cert.ente}</span>
                      </div>
                    </div>
                  </div>
                  
                  {/* Pulsante download */}
                  <div className="p-6 bg-gray-50 group-hover:bg-gray-100 transition-colors duration-300">
                    <a 
                      href={cert.pdfUrl} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      download
                      className="relative overflow-hidden w-full flex items-center justify-center gap-3 py-4 px-6 rounded-xl font-medium transition-all duration-300 text-white shadow-lg hover:shadow-xl"
                      style={{ backgroundColor: primaryColor }}
                    >
                      <span className="absolute inset-0 w-full h-full bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-300"></span>
                      <Download 
                        size={18} 
                        className="transition-transform duration-300 group-hover:translate-y-1" 
                      />
                      <span>Scarica Certificato PDF</span>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}

          {activeTab === 'normative' && (
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
              <div className="p-8 border-b border-gray-100" style={{ backgroundColor: 'rgba(35, 45, 59, 0.03)' }}>
                <h3 className="text-2xl font-bold mb-2" style={{ color: primaryColor }}>Standard Normativi</h3>
                <p className="text-gray-600">
                  La nostra attività è conforme ai seguenti regolamenti che disciplinano la gestione e il commercio di materiali End of Waste.
                </p>
              </div>
              
              <div className="p-8">
                <div className="space-y-8">
                  {normative.map((norma, index) => (
                    <div key={index} className="group flex items-start p-6 rounded-xl border border-gray-100 hover:border-gray-200 transition-all duration-300 hover:shadow-md">
                      <div 
                        className="flex-shrink-0 p-3 rounded-lg mr-5 transition-all duration-300" 
                        style={{ backgroundColor: 'rgba(35, 45, 59, 0.07)' }}
                      >
                        {norma.icona}
                      </div>
                      
                      <div className="flex-1">
                        <div className="flex flex-wrap items-center justify-between mb-2">
                          <h4 className="text-lg font-bold" style={{ color: primaryColor }}>{norma.numero}</h4>
                          <span className="text-xs font-medium px-3 py-1 rounded-full bg-amber-100 text-amber-800">
                            {norma.titolo}
                          </span>
                        </div>
                        <p className="text-gray-600 text-sm mb-3">{norma.descrizione}</p>
                        <a 
                          href="https://eur-lex.europa.eu/homepage.html" 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="inline-flex items-center text-xs font-medium py-1.5 px-3 rounded-full group-hover:underline transition-colors"
                          style={{ color: primaryColor, backgroundColor: 'rgba(35, 45, 59, 0.05)' }}
                        >
                          Consulta testo ufficiale <ExternalLink size={12} className="ml-1.5" />
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Call to action finale */}
        <div className="text-center mt-4 p-8 rounded-2xl bg-white shadow-lg border border-gray-100">
          <h4 className="text-xl font-bold mb-3" style={{ color: primaryColor }}>Conformità garantita</h4>
          <p className="text-gray-600 mb-6 max-w-3xl mx-auto">
            Tutte le nostre attività di commercio e intermediazione di materiali metallici sono svolte nel rigoroso rispetto delle normative 
            ambientali vigenti. La documentazione completa è disponibile per verifiche e audit presso la nostra sede operativa.
          </p>
          <a 
            href="#contatti" 
            className="inline-flex items-center py-3 px-8 rounded-xl font-medium text-white shadow-lg transition-all duration-300 hover:shadow-xl"
            style={{ backgroundColor: primaryColor }}
          >
            Contattaci per Maggiori Informazioni
          </a>
        </div>
      </div>
    </section>
  );
};

export default Certificazioni;